module.exports = __webpack_public_path__ + "static/mapmobile-297bde1a37ea8e849945aa79aa2f8911.png";